module.exports = __webpack_public_path__ + "img/Henri_Lichenstein.ac0d7ca9.png";